const Container = ({ children }) => {
    return (
        <div className="container p-8 lg:p-10 xl:p-16 text-center mx-auto max-w-screen-lg">
                {children}
        </div>
    );
};

export default Container;
